<main>
    <!-- List Details -->
    <div>
        <div class="csq-head flex-wrap gap-2">
            <div class="d-flex align-items-center gap-3" style="cursor: pointer;" (click)="goBack()">
                <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
                <div class="header-text csq-text">
                    CSQ team management
                </div>
            </div>
            <div class="d-flex gap-3 align-items-center res-container">
                <!-- <div> -->
                    <div class="search-container">
                        <div class="search-icon">
                            <img src="assets/icons/side-bar/search-normal.svg" alt="search"
                                style="width: 18px; height: 18px;" />
                        </div>
                        <input type="text" placeholder="Search here..." class="search-input" [(ngModel)]="search"
                            (input)="updateSearch(search)" (keyup.enter)="applyFilter()" autocomplete="off" />
                    </div>
                <!-- </div> -->
                <app-button label="Add new csq member" *ngIf="userRoles.addNew" [minWidth]="'14.813rem'"
                    (clicked)="openAddDialog()"></app-button>
            </div>
        </div>

        <div>
            <div class="table-card">
                <app-table [columns]="columns" [data]="data" [actionTemplate]="actionButtonsTemplate"
                    [loading]="loading" (statusClick)="onStatusUpdate($event)" >
                </app-table>
            </div>
        </div>
    </div>

</main>

<ng-template #actionButtons let-row>
    <div style="display: flex; gap: 0.8rem; justify-content: center;">
        <img class="action-button" *ngIf="userRoles.listItem.view" (click)="onView(row)"
            src="assets/images/Buttons/view-button.svg" alt="View" />
        <img class="action-button" *ngIf="userRoles.listItem.edit" (click)="onEdit(row)"
            src="assets/images/Buttons/edit-button.svg" alt="Edit" />
        <img class="action-button" *ngIf="userRoles.listItem.delete" (click)="onDelete(row)"
            src="assets/images/Buttons/delete-button.svg" alt="Delete" />
    </div>
</ng-template>


<ng-template #addCSQContent>
    <div class="dialog-content">
        <form [formGroup]="form" class="d-grid gap-14">

            <div class="grid-container">
                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="First name" placeholder="Enter your first name"
                        type="text" [control]="form.get('firstName')" formControlName="firstName" [required]="true"
                        [control]="form.get('firstName')" [customErrorMessages]="customErrorMessages.firstName">
                    </app-input>
                </div>

                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Last name" placeholder="Enter your last name"
                        type="text" [control]="form.get('lastName')" formControlName="lastName" [required]="true"
                        [control]="form.get('lastName')" [customErrorMessages]="customErrorMessages.lastName">
                    </app-input>
                </div>
            </div>

            <div class="grid-container">
                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Email" placeholder="Enter your email"
                        type="email" formControlName="email" [control]="form.get('email')" [required]="true"
                        [customErrorMessages]="customErrorMessages.email">
                    </app-input>
                </div>

                <div class="form-group">
                    <app-input context="Normal" class="form-item" label="Phone number" [required]="true"
                        placeholder="Enter your phone number" type="text" formControlName="mobileNumber"
                        [control]="form.get('mobileNumber')" [customErrorMessages]="customErrorMessages.mobileNumber">
                    </app-input>
                </div>
            </div>

        </form>
    </div>
</ng-template>